import React, { useState } from 'react';
import { css } from 'astroturf';

const styles = css`
  .urlbar {
    position: relative;
    margin: 2rem auto;
    max-width: 60vh;
    padding: 0.5rem;
    background: hsla(0, 0%, 100%, 0.26666666666666666);
    border-radius: 30px;
    backdrop-filter: blur(10px);
    box-shadow:
      0 -1px 1px 0 hsla(0, 0%, 100%, 0.55),
      20px 10px 20px 0 rgba(5, 9, 12, 0.55);

    .bar {
      display: block;
      background: #fff;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      border-radius: 15px;
      text-align: left;
      padding-left: 20px;
      padding-right: 50px;
      color: #0008;
      box-shadow:
        0 -1px 1px 0 hsla(0, 0%, 100%, 0.55),
        20px 10px 20px 0 rgba(5, 9, 12, 0.55);
    }

    .sharer {
      position: absolute;
      top: 12px;
      right: 16px;

      .popup {
        position: absolute;
        top: 27px;
        right: -4px;
        margin: 0;
        padding: 0;
        list-style: none;
        position: absolute;
        border-top: 1px solid #fff8;
        background: hsl(224deg 12% 30%);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        transition: 0.15s ease-in-out opacity;
        width: 300px;
        max-width: calc(100vw - 5rem);
        padding: 8px 8px 12px;
        color: #d0d0d5;

        &::before {
          content: ' ';
          position: absolute;
          pointer-events: none;
          bottom: 100%;
          right: 8px;
          border-width: 6px 6px 6px 6px;
          border-style: solid;
          border-color: transparent transparent hsl(224deg 12% 30%) transparent;
        }

        & p {
          text-align: left;
          color: #d0d0d5;
          text-shadow: none;
          font-size: 13px;
          margin: 0;
          padding: 0;
        }
      }
    }
  }

  .popup {
    .toggle {
      position: relative;
      border-radius: 4px;
      border: 0;
      outline: none;
      background: #2b2e37;
      width: calc(100% + 8px);
      margin-left: -4px;
      height: 32px;
      display: flex;
      justify-content: flex-start;
      font-size: 13px;
      line-height: 20px;
      padding: 4px;
      margin: 1rem 0;

      width: calc(100% - 16px);
      margin-right: 16px;

      &::before {
        content: ' ';
        background: hsl(224deg 12% 24%);
        border: 0;
        border-radius: 4px;
        padding: 4px;
        margin: 0px;
        color: rgb(1, 17, 101);
        transition: 0.15s ease-in-out transform;
        opacity: 1;
        width: calc(50% - 4px);
        position: absolute;
        left: 4px;
        top: 4px;
        height: calc(100% - 8px);
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
      }

      &.mode-2::before {
        transform: translateX(100%);
      }

      span {
        position: relative;
        display: inline-block;
        background: none;
        border: 0;
        border-radius: 4px;
        padding: 0 2px;
        margin: 2px 0;
        color: #d0d0d5;
        transition: 0.15s 0s opacity ease-in-out;
        opacity: 0.6;
        flex: 1;
        font-weight: 600;
        text-align: center;
      }

      .toggleTooltip {
        position: absolute;
        right: -20px;
        top: 4px;
      }
    }

    .buttons {
      margin: 1rem 1rem 0 0;
      display: flex;
      gap: 0.5rem;

      .submitbutton {
        flex: 0 0 auto;
        align-self: center;
        display: block;
        width: fit-content;
        position: relative;
        margin-left: auto;
        background: none;
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        border: 0;
        color: inherit;
        user-select: none;
        font-weight: 500;
        padding: 4px 6px;
        transition:
          0.15s ease-in-out opacity,
          0.15s ease-in-out background;
        background: #008945;
        color: #fff;

        &:hover {
          background: #639cb8;
        }
      }
    }
  }
`;

const URLBar = ({ setPortalAnim }) => {
  const [portalState, setPortalState] = useState('Network');

  const togglePortal = () => {
    setPortalState(portalState === 'Network' ? 'Public' : 'Network');
  };

  return (
    <div className={styles.urlbar}>
      <div className={styles.bar}>http://localhost:1337</div>
      <div className={styles.sharer}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
          <path d="M12 21c-3.314 0 -6 -2.462 -6 -5.5s2.686 -5.5 6 -5.5" />
          <path d="M21 12c0 3.314 -2.462 6 -5.5 6s-5.5 -2.686 -5.5 -6" />
          <path d="M12 14c3.314 0 6 -2.462 6 -5.5s-2.686 -5.5 -6 -5.5" />
          <path d="M14 12c0 -3.314 -2.462 -6 -5.5 -6s-5.5 2.686 -5.5 6" />
        </svg>

        <div className={styles.popup}>
          <p>
            <b>Open {portalState} Portal</b>
          </p>
          <p>Keep other browsers in sync with Polypane.</p>

          <button
            className={[styles.toggle, portalState === 'Public' ? styles.mode2 : ''].join(' ')}
            type="button"
            onClick={togglePortal}
          >
            <span>Network</span>
            <span>Public</span>
            <span
              className={styles.toggleTooltip}
              data-tip={`<span style="display:block;width: 350px;padding:0.5rem 0;"><b>Network portals</b> are available on your local network. <b>Public portals</b> are available to the world.</span>`}
            >
              <svg
                id="i-info"
                viewBox="0 0 32 32"
                width="12"
                height="12"
                fill="none"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="6.25%"
              >
                <path d="M16 14 L16 23 M16 8 L16 10" />
                <circle cx="16" cy="16" r="14" />
              </svg>
            </span>
          </button>
          <div className={styles.buttons}>
            <button
              className={styles.submitbutton}
              type="button"
              data-tip="Works in Polypane"
              onMouseEnter={() => {
                setPortalAnim(true);
              }}
              onMouseLeave={() => {
                setPortalAnim(false);
              }}
            >
              Open portal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default URLBar;
